<template>
  <!-- 新员工排名 -->
  <!-- v-loading="isShow" element-loading-text="拼命加载中" -->
  <el-container>
    <div class="comp">
      <div class="nucleustit">
        <div class="tit">{{ curStaffMsg.staffName }}({{curStaffMsg.position  }})</div>
        <div class="tabList">
          <el-select filterable style="width: 150px" :disabled="!$buttonAuthority('shuju-Newmoneypk-Staffswitch')"
            v-model="curStaffMsg" value-key="staffId" placeholder="请选择员工" size="mini" @change="changeStaff">
            <el-option v-for="item in staffList" :key="item.staffId" :label="item.staffName" :value="item">
            </el-option>
          </el-select>
          <el-date-picker style="width: 130px; margin-left: 10px" size="mini" v-model="currDate" type="month"
            value-format="timestamp" :picker-options="{
              disabledDate(date) {
                return date.getTime() < 1698768000000;
              },
            }" placeholder="选择日期" @change="changePicker" :clearable="false">
          </el-date-picker>
          <div class="tabI" v-if="$buttonAuthority('shuju-Newmoneypk-royalty')" @click="SetList" >
            提成设置
          </div>
          <div class="tabI" v-if="$buttonAuthority('shuju-Newmoneypk-seal')" @click="DataFile" >
            数据归档
          </div>
          <div class="tabI" v-if="$buttonAuthority('shuju-Newmoneypk-seal')"  @click="DataExport" >
            数据导出
          </div>
          <div class="tabI" v-if="$buttonAuthority('shuju-Newmoneypk-seal')"  @click="Add" >
            插入差额订单
          </div>
        </div>

      </div>
      <div class="panelBox">
        <div class="panel">
          <div style="display: flex;justify-content: space-between;align-items: center;">
            <div class="tit">数据</div>

            <div class="cell">
              <!-- <div>{{ datas.staffCommissionMonthStatic.commissionSum.money }} </div> -->
            </div>
          </div>
          <div class="nucleuscon">
            <div class="nucleusitem">
              <div class="content">
                <div class="currentit">{{ datas.staffCommissionMonthStatic.commissionSum.moneyName }}</div>
                <div class="data">
                  <div class="cell1"> {{ datas.staffCommissionMonthStatic.commissionSum.money.toFixed(2) }}
                  </div>
                </div>
              </div>
            </div>
            <div class="nucleusitem">
              <div class="content">
                <div class="currentit">{{ datas.staffCommissionMonthStatic.performanceSum.moneyName }}</div>
                <div class="data">
                  <div class="cell1"> {{ datas.staffCommissionMonthStatic.performanceSum.money.toFixed(2) }}
                  </div>
                </div>
              </div>
            </div>
            <div class="nucleusitem">
              <div class="content">
                <div class="currentit">{{ datas.staffCommissionMonthDetail.subsidy.totalMoney.moneyName }}</div>
                <div class="data">
                  <div class="cell1"> {{ datas.staffCommissionMonthDetail.subsidy.totalMoney.money.toFixed(2) }}
                  </div>
                </div>
              </div>
            </div>
            <div class="nucleusitem">
              <div class="content">
                <div class="currentit">{{ datas.staffCommissionMonthStatic.serviceCount.moneyName }}</div>
                <div class="data">
                  <div class="cell1"> {{ datas.staffCommissionMonthStatic.serviceCount.money.toFixed(2) }}
                  </div>
                </div>
              </div>
            </div>
            <div class="nucleusitem">
              <div class="content">
                <div class="currentit">{{ datas.staffCommissionMonthStatic.orderCount.moneyName }}</div>
                <div class="data">
                  <div class="cell1"> {{ datas.staffCommissionMonthStatic.orderCount.money.toFixed(2) }}
                  </div>
                </div>
              </div>
            </div>
            <div class="nucleusitem">
              <div class="content">
                <div class="currentit">{{ datas.staffCommissionMonthStatic.returnMoney.moneyName }}</div>
                <div class="data">
                  <div class="cell1"> {{ datas.staffCommissionMonthStatic.returnMoney.money.toFixed(2) }}
                  </div>
                </div>
              </div>
            </div>
        </div>

      <div class="nucleuscon">
            <div class="nucleusitem">
              <div class="content">
                <div class="currentit">{{ datas.staffCommissionMonthStatic.petPerformanceSum.moneyName }}</div>
                <div class="data">
                  <div class="cell1"> {{ datas.staffCommissionMonthStatic.petPerformanceSum.money.toFixed(2) }}
                  </div>
                </div>
              </div>
            </div>
            <div class="nucleusitem">
              <div class="content">
                <div class="currentit">{{ datas.staffCommissionMonthStatic.petPerformanceSumTake.moneyName }}</div>
                <div class="data">
                  <div class="cell1"> {{ datas.staffCommissionMonthStatic.petPerformanceSumTake.money.toFixed(2) }}
                  </div>
                </div>
              </div>
            </div>
            <div class="nucleusitem">
              <div class="content">
                <div class="currentit">{{ datas.staffCommissionMonthStatic.petPerformanceSumNoTake.moneyName }}</div>
                <div class="data">
                  <div class="cell1"> {{ datas.staffCommissionMonthStatic.petPerformanceSumNoTake.money.toFixed(2) }}
                  </div>
                </div>
              </div>
            </div>
            <div class="nucleusitem">
              <div class="content">
                <div class="currentit">{{ datas.staffCommissionMonthStatic.differencePrice.moneyName }}</div>
                <div class="data">
                  <div class="cell1"> {{ datas.staffCommissionMonthStatic.differencePrice.money.toFixed(2) }}
                  </div>
                </div>
              </div>
            </div>
            <div class="nucleusitem">
              <div class="content">
                <div class="currentit">总业绩提成</div>
                <div class="data">
                  <div class="cell1"> {{ (datas.staffCommissionMonthStatic.commissionSum.money+datas.staffCommissionMonthStatic.differencePrice.money).toFixed(2)  }}
                  </div>
                </div>
              </div>
            </div>
            <div class="nucleusitem">
              <div class="content">
                
               
              </div>
            </div>
        </div> 
        </div>
        <div class="panel2">
          <div class="tit">当月业绩饼状图</div>
          <div  id="myChart0" style="height: 200px;"></div>
        </div>
      </div>
      <!-- 月目标完成度 -->
      <div class="panelBox">
        <div class="R">
          <div class="rulesLine">
            <div class="money">
              提成金额<span style="font-size: 18px; color: #333; font-weight: bold">
                <!-- {{
                datas.staffStaticModel.royaltyMoney &&
                datas.staffStaticModel.royaltyMoney.money
              }} -->
              </span>
            </div>
          </div>
          <div class="scoll">
            <!-- 商品 -->
            <div class="tabBox">
              <div class="tabTit">
                <div class="colTit">
                  类目
                </div>
                <div class="colTit"> {{ datas.staffCommissionMonthDetail.goods.performance.moneyName }}</div>
                <div class="colTit">{{ datas.staffCommissionMonthDetail.goods.ratio.moneyName }}</div>
                <div class="colTit">{{ datas.staffCommissionMonthDetail.goods.commission.moneyName }}</div>
                <div class="colTit see">
                  操作
                </div>
              </div>
              <div class="tabItem">
                <div class="colTit"> 活体业绩</div>
                <div class="colTit"> {{ datas.staffCommissionMonthDetail.petSales.performance.money.toFixed(2) }}</div>
                <div class="colTit">{{ (datas.staffCommissionMonthDetail.petSales.ratio.money*100.0).toFixed(2) }}%</div>
                <div class="colTit">{{ datas.staffCommissionMonthDetail.petSales.commission.money.toFixed(2) }}</div>
                <div class="colTit see" @click="toDetail(datas.staffCommissionMonthDetail.petSales,[18])">
                  查看
                </div>
              </div>
              <div class="tabItem">
                <div class="colTit"> 活体奖金</div>
               
                <div class="colTit"> {{ datas.staffCommissionMonthDetail.petBonus.money.toFixed(2) }}</div>
                <div class="colTit"></div>
                <div class="colTit"></div>
                <!-- <div class="colTit">{{ datas.staffCommissionMonthDetail.petBonus.ratio.money.toFixed(2) }}</div>
                <div class="colTit">{{ datas.staffCommissionMonthDetail.petBonus.commission.money.toFixed(2) }}</div> -->
                <div class="colTit see" @click="toDetail(datas.staffCommissionMonthDetail.petBonus,[19])">
                  查看
                </div>
              </div>
              <div class="tabItem">
                <div class="colTit"> 商品</div>
                <div class="colTit"> {{ datas.staffCommissionMonthDetail.goods.performance.money.toFixed(2) }}</div>
                <div class="colTit">{{ (datas.staffCommissionMonthDetail.goods.ratio.money*100.0).toFixed(2) }}%</div>
                <div class="colTit">{{ datas.staffCommissionMonthDetail.goods.commission.money.toFixed(2) }}</div>
                <div class="colTit see"  @click="toDetail(datas.staffCommissionMonthDetail.goods,[1])">
                  查看
                </div>
              </div>
              <div class="tabItem">
                <div class="colTit"> 洗澡</div>
                <div class="colTit"> {{ datas.staffCommissionMonthDetail.bathe.performance.money.toFixed(2) }}</div>
                <div class="colTit">{{ (datas.staffCommissionMonthDetail.bathe.ratio.money*100.0).toFixed(2) }}%</div>
                <div class="colTit">{{ datas.staffCommissionMonthDetail.bathe.commission.money.toFixed(2) }}</div>
                <div class="colTit see" @click="toDetail(datas.staffCommissionMonthDetail.bathe,[3])">
                  查看
                </div>
              </div>
              <div class="tabItem">
                <div class="colTit"> 美容</div>
                <div class="colTit"> {{ datas.staffCommissionMonthDetail.cosmetology.performance.money.toFixed(2) }}</div>
                <div class="colTit">{{ (datas.staffCommissionMonthDetail.cosmetology.ratio.money*100.0).toFixed(2) }}%</div>
                <div class="colTit">{{ datas.staffCommissionMonthDetail.cosmetology.commission.money.toFixed(2) }}</div>
                <div class="colTit see" @click="toDetail(datas.staffCommissionMonthDetail.cosmetology,[2])">
                  查看
                </div>
              </div>
              <div class="tabItem">
                <div class="colTit"> 医疗</div>
                <div class="colTit"> {{ datas.staffCommissionMonthDetail.medical.performance.money.toFixed(2) }}</div>
                <div class="colTit">{{ (datas.staffCommissionMonthDetail.medical.ratio.money*100.0).toFixed(2) }}%</div>
                <div class="colTit">{{ datas.staffCommissionMonthDetail.medical.commission.money.toFixed(2) }}</div>
                <div class="colTit see" @click="toDetail(datas.staffCommissionMonthDetail.medical,[4,5,6])">
                  查看
                </div>
              </div>
              <div class="tabItem">
                <div class="colTit"> 套餐销售</div>
                <div class="colTit"> {{ datas.staffCommissionMonthDetail.package.performance.money.toFixed(2) }}</div>
                <div class="colTit">{{ (datas.staffCommissionMonthDetail.package.ratio.money*100.0).toFixed(2) }}%</div>
                <div class="colTit">{{ datas.staffCommissionMonthDetail.package.commission.money.toFixed(2) }}</div>
                <div class="colTit see" @click="toDetail(datas.staffCommissionMonthDetail.package,[7,8,9])">
                  查看
                </div>
              </div>
              <div class="tabItem">
                <div class="colTit"> 会员卡</div>
                <div class="colTit"> {{ datas.staffCommissionMonthDetail.vipCard.performance.money.toFixed(2) }}</div>
                <div class="colTit">{{ (datas.staffCommissionMonthDetail.vipCard.ratio.money*100.0).toFixed(2) }}%</div>
                <div class="colTit">{{ datas.staffCommissionMonthDetail.vipCard.commission.money.toFixed(2) }}</div>
                <div class="colTit see" @click="toDetail(datas.staffCommissionMonthDetail.vipCard,[20])">
                  查看
                </div>
              </div>
              <div class="tabItem">
                <div class="colTit"> 医助跟诊</div>
                <div class="colTit"> {{ datas.staffCommissionMonthDetail.follow.performance.money.toFixed(2) }}</div>
                <div class="colTit">{{ (datas.staffCommissionMonthDetail.follow.ratio.money*100.0).toFixed(2) }}%</div>
                <div class="colTit">{{ datas.staffCommissionMonthDetail.follow.commission.money.toFixed(2) }}</div>
                <div class="colTit see" @click="toDetail(datas.staffCommissionMonthDetail.follow,[11])">
                  查看
                </div>
              </div>
           
              <div class="tabItem">
                <div class="colTit"> 寄养</div>
                <div class="colTit"> {{ datas.staffCommissionMonthDetail.foster.performance.money.toFixed(2) }}</div>
                <div class="colTit">{{ (datas.staffCommissionMonthDetail.foster.ratio.money*100.0).toFixed(2) }}%</div>
                <div class="colTit">{{ datas.staffCommissionMonthDetail.foster.commission.money.toFixed(2) }}</div>
                <div class="colTit see" @click="toDetail(datas.staffCommissionMonthDetail.foster,[10])">
                  查看
                </div>
              </div>
              <div class="tabItem1">
                <el-collapse accordion>
                  <el-collapse-item>
                    <template slot="title">
                      <div class="colTit">{{ datas.staffCommissionMonthDetail.subsidy.totalMoney.moneyName}}</div>
                      <div class="colTit">{{ datas.staffCommissionMonthDetail.subsidy.totalMoney.money.toFixed(2)}}</div>
                      <div class="colTit"></div>
                <div class="colTit"></div>
                       <div class="colTit see" @click="toDetail(datas.staffCommissionMonthDetail.subsidy,[12,13,14,15,16,17])"> 查看 </div>
                    </template>
                <div class="tabItem2" v-for="(item, index) in datas.staffCommissionMonthDetail.subsidy.list" :key="index">
                <div class="colTit"> {{ item.moneyName }}</div>
                <div class="colTit">{{ item.money.toFixed(2) }}</div>
               </div>
                  </el-collapse-item>
                </el-collapse>
              </div>
              <div class="tabItem1">
                <el-collapse accordion>
                  <el-collapse-item>
                    <template slot="title">
                      <div class="colTit">{{ datas.staffCommissionMonthDetail.differencePrice.sum.moneyName}}</div>
                      <div class="colTit">{{ datas.staffCommissionMonthDetail.differencePrice.sum.money.toFixed(2)}}</div>
                      <div class="colTit"></div>
                <div class="colTit"></div>
                      
                    </template>
                <div class="tabItem2" v-for="(item, index) in datas.staffCommissionMonthDetail.differencePrice.differenceList" :key="index">
                <div class="colTit"> {{ item.montName }}</div>
                <div class="colTit">{{ item.monthSum.money.toFixed(2) }}</div>
                <div class="colTit see" @click="getDetail(item)"> 查看 </div>
               </div>
                  </el-collapse-item>
                </el-collapse>

              </div>
            </div>
          </div>
        </div>
        <!-- 员工业绩详情弹框 -->
        <div v-if="drawerSee_state">
      <drawerSee :time="time" :type="type" :staffId="curStaffMsg.staffId" @submit="submit_drawerSee"></drawerSee>
    </div>
    <!-- 员工往月业绩差额详情弹框 -->
        <div v-if="drawerMonth_state">
      <drawerMonth :time="time" :type="type1" :staffId="curStaffMsg.staffId" @submit="submit_drawerMonth"></drawerMonth>
    </div>
        <!-- 设置提成规划 -->
        <div v-if="drawerAdd_state">
      <drawerAdd  @submit="submit_drawerAdd"></drawerAdd>
    </div>
      </div>
      <el-dialog
        title="添加提成订单"
        :modal-append-to-body="false"
        :visible.sync="dialogAddVisible"
        width="40%"
        :before-close="handleAddClose"
        append-to-body
      >
        <el-input
          v-model="No"
          placeholder="请输入订单号"
          style="width: 240px; margin-right: 16px"
        ></el-input>
        <el-button type="warning" plain @click="AddOrder"
          >添加订单</el-button
        >
        <el-form v-if="OrderDetail">
          <el-form-item label="商品名称">
            <el-input
              disabled
              type="text"
              :value="
                OrderDetail.order_item_list[0].order_item_goods_list[0]
                  .goods_name +
                '-' +
                OrderDetail.order_item_list[0].order_item_goods_list[0].model
              "
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="门店">
            <el-input
              disabled
              type="text"
              :value="OrderDetail.company_info.shop_name"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="销售人员">
            <el-input
              disabled
              type="text"
              :value="OrderDetail.order_item_list[0].sales_list[0].sales_name"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="业绩金额">
            <el-input type="number" v-model="commission" clearable></el-input>
          </el-form-item>
          <el-form-item label="提成金额">
            <el-input type="number" v-model="performance" clearable></el-input>
          </el-form-item>
          <el-form-item label="提成差价金额">
            <el-input type="number" v-model="difference" clearable></el-input>
          </el-form-item>
          <div class="inputLine">
                        <div class="label">时间：</div>
                        <el-date-picker v-model="updateOrderTime" @change="changeDatetime" type="datetime" placeholder="请选择时间"
                            style="width: 200px"></el-date-picker>
                        <p @click="updateOrderTime = new Date()" style="font-size: 14px;line-height: 40px; color: #1890ff;text-decoration: underline;
                  cursor: pointer;">填入当前时间
                        </p>
                    </div>
          <el-form-item label="备注">
            <el-input type="text" v-model="remark1" clearable></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogAddVisible = false">取消</el-button>
          <el-button type="primary" @click="RegisterAddVisible"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
  </el-container>
</template>
<script>
import moment from "moment";
import axios from 'axios';
import echarts from "echarts";
import drawerSee from "./staffroyaltyDetail.vue";
import drawerAdd from "./newpk/staffSeeParams.vue";
import drawerMonth from "./staffroyaltymonth.vue";
export default {
  components: {drawerSee,drawerAdd,drawerMonth },
  data() {
    return {
      isShow: false,
      difference: "",
      performance: "",
      commission: "",
      remark1: "",
      updateOrderTime:"",
      OrderDetail: null,
      dialogAddVisible: false, //提成
      No: "",
      datas: {
        staffCommissionMonthDetail: {},
        staffCommissionMonthStatic: {}
      },
      myChart0: null,
      drawerAdd_state: false, //新建弹框
      drawerSee_state:false,
      drawerMonth_state:false,
      curStaffMsg: { staffName: "", staffId: "", position: "" },
      staffList: [],
      currDate: new Date(),
      time:'',
      type:[],
      type1:[],
      shopId: null,
      shopOptions: [{ //门店筛选
        value: '',
        label: '全部'
      }, {
        value: '5e9412e0b2bfbc089daerr12',
        label: '北环店'
      }, {
        value: '5e9412e0b2bfbc089daerr16',
        label: '二七店'
      }, {
        value: '5e9412e0b2bfbc089daerr18',
        label: '云尚店'
      }, {
        value: '5e9412e0b2bfbc089daerr15',
        label: '东区店'
      }],

    };
  },
  props: {
    // refresh: {
    //   default: 0,
    // },
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo;
    },
  },
  watch: {
    // refresh() {
    //   this.getDatas();
    //   this.getdays();
    // },
  },
  created() {
    this.getStaffList();
    this.currDate = new Date();
    sessionStorage.setItem("pkMonth", this.$public.FTimeStr10(this.currDate));
    this.getDatas();

  },
  mounted() {
  },
  methods: {
    handleAddClose(done) {
      this.$emit("close");
    },
    Add() {
      this.dialogAddVisible = true;
    },
    // 添加订单
    AddOrder() {
      if (this.No) {
        this.$http
          .get(process.env.VUE_APP_Url_order + "/api/OffLineOrder/" + this.No)
          .then((res) => {
            if (res.code == 0) {
              if (res.data.order_type_id == "8") {
                console.log(res, "ress");
                this.OrderDetail = res.data;
              } else {
                this.$message({
                  type: "success",
                  message: "请输入活体单号",
                });
              }
            }
          });
      }
    },
    changeDatetime(val) {
        },
    RegisterAddVisible() {
      if (!this.difference) {
        this.$message.error("请完善信息");
        return;
      }
      if (!this.performance) {
        this.$message.error("请完善信息");
        return;
      }
      if (!this.commission) {
        this.$message.error("请完善信息");
        return;
      }
      if (!this.remark1) {
        this.$message.error("请完善信息");
        return;
      }
      if (this.updateOrderTime == "") {
                this.$message({
                    type: "error",
                    message: "请选择发布时间",
                });
                return;
            }
      let params = {
        shopId: this.OrderDetail.company_info.shop_id,
        orderNo: this.No,
        orderItemId:
          this.OrderDetail.order_item_list[0].order_item_goods_list[0]
            .goods_name +
          "-" +
          this.OrderDetail.order_item_list[0].order_item_goods_list[0].model,
        orderPayTime: this.$public.FTime(this.OrderDetail.pay_info.pay_time),
        staffId: this.OrderDetail.order_item_list[0].sales_list[0].sales_id,
        staffName: this.OrderDetail.order_item_list[0].sales_list[0].sales_name,
        differencePrice: this.difference,
        performanceMoney: this.performance,
        commissionMoney: this.commission,
        remark: this.remark1,
        updateOrderTime: moment(this.updateOrderTime.getTime()).format("YYYY-MM-DD HH:mm:ss"),
      };
      this.$http
        .post(
          process.env.VUE_APP_zichan +
            "/api/Performance/CreateStaffCommission",
          params
        )
        .then((res) => {
          if (res.code == 0) {
            console.log(res,"pppppp");
            this.$message({
              type: "success",
              message: "添加成功",
            });
            this.dialogAddVisible = false;
          }
        });
    },
    submit_drawerSee() {
      this.drawerSee_state = false;
    },
    submit_drawerMonth() {
      this.drawerMonth_state = false;
    },
    // 员工
    changeStaff(val) {
      console.log(val, "val");
      this.curStaffMsg = val;
      this.getDatas();
    },
    getStaffList() {
      this.$http
        .get(
          process.env.VUE_APP_zichan + "/api/Performance/GetShopStaffList")
        .then((res) => {
          if (res.code === 0) {
            res.data.forEach((item) => {
              this.staffList.push({
                staffId: item._id, staffName: item.basic_info.real_name, position: item.department
              })
            });
            this.curStaffMsg = {}
            for (let i = 0; i < this.staffList.length; i++) {
              if (this.userInfo.staffId === this.staffList[i].staffId) {
                this.curStaffMsg = this.staffList[i];
              }
            }
            this.getDatas();
          }
        });
    },
    // 往月差额详情
    getDetail(item){
      this.staffId=this.curStaffMsg.staffId
      this.type1=item
      this.time=moment(this.$public.Timer(this.currDate)).format("YYYY-MM-DD")
      console.log(item,this.time,this.staffId,'objbjbj');
      this.drawerMonth_state=true;
    },
    // 去提成详情
    toDetail(e,obj){
      this.type=obj
      this.time=moment(this.$public.Timer(this.currDate)).format("YYYY-MM-DD")
      this.drawerSee_state = true;
      console.log(this.time,'time');
    },
    // 提成设置列表
    SetList(){
      this.drawerAdd_state = true;
        
    },
    // 数据导出
    DataExport(){
      let params = {
        month: this.$public.FTime(
          sessionStorage.getItem("pkMonth"),
          "YYYY-MM"
        ), // 月份信息(2021-10)
        staffId:this.curStaffMsg.staffId
						}
						let loading = this.$loading();
						axios.get(process.env.VUE_APP_zichan+'/api/Performance/ExportStaffCommissionRecordList', {
							params: params,
							responseType: 'blob'
						}).then(response => {
							var href = window.URL.createObjectURL(response.data); //创建下载的链接
							var downloadElement = document.createElement('a');
							downloadElement.href = href;
							downloadElement.download =this.curStaffMsg.staffName+'业绩数据.xlsx';
							document.body.appendChild(downloadElement);
							downloadElement.click(); //点击下载
							document.body.removeChild(downloadElement); //下载完成移除元素
							window.URL.revokeObjectURL(href); //释放掉blob对象
							loading.close();
						}).catch(err => {
							console.log(err)
						})
    },
    // 数据归档
    DataFile(){
      let params = {
        month: this.$public.FTime(
          sessionStorage.getItem("pkMonth"),
          "YYYY-MM"
        ), // 月份信息(2021-10)
       
      };
      this.isShow = true;
      let loading = this.$loading();
      this.$http
        .get(process.env.VUE_APP_zichan+"/api/Performance/DataFile",
          params
        )
        .then((res) => {
          loading.close();
          this.isShow = false;
          if (res.code == 0) {
            console.log('11');
          }
        });
    },
    changePicker(e) {
      console.log(e, 'e');
      sessionStorage.setItem("pkMonth", this.$public.FTimeStr10(e));
      this.getDatas()
      //   this.refresh++;
    },
    // 表格数据
    getDatas() {
      // this.state1 = false;
      if (this.$public.isNull(this.curStaffMsg.staffId)) {
        this.curStaffMsg = this.staffList[0];
      }
      let params = {
        month: this.$public.FTime(
          sessionStorage.getItem("pkMonth"),
          "YYYY-MM"
        ), // 月份信息(2021-10)
        staffId:this.curStaffMsg.staffId
      };
      this.isShow = true;
      let loading = this.$loading();
      // process.env.VUE_APP_zichan +
      this.$http
        .get(process.env.VUE_APP_zichan +"/api/Performance/GetStaffDataResponse",
          params
        )
        .then((res) => {
          loading.close();
          this.isShow = false;
          if (res.code == 0) {
            this.datas = res.data;
            console.log(this.datas, "数据");
            this.$nextTick(() => {
              setTimeout(() => {
            this.draw0()
          }, 1000)
          });
          }
        });
    },
    // handleAdd(){
    //     this.drawerAdd_state = true;
    //   },
      submit_drawerAdd() {
      this.drawerAdd_state = false;
    },
    draw0() {
            this.myChart0 = echarts.init(document.getElementById("myChart0"));
            let list = this.datas.staffCommissionMonthStatic;
            let listItem = [{ value: (list.petPerformanceSum.money), name: '活体销售金额' }, { value: (list.washPerformanceSum.money), name: '洗美销售金额' }, { value: (list.medicalPerformanceSum.money), name: '医疗销售金额' }, { value: (list.goodsPerformanceSum.money), name: '商品销售金额' }];
    
            // for (let i = 0; i < listItem.length; i++) {
            //     arr.push(listItem[i])
            // }
            this.myChart0.setOption({
                color: [
                    "#F5882A",
                    "#58A2F7",
                    "#FBCB63",
                    "#F76260",
                    "#8167F5",
                    "#F5EC67",
                    "#28D3DB",
                    "#96D9FF",
                ],
                legend: {
                    orient: 'horizontal',
                    x: 'top',
                    textStyle: {
                        fontSize: "16",
                        color: "#8C8C8C",
                        lineHeight: "10",
                    },
                    itemGap: 10,
                    data: listItem      
                    },
                series: [
                    {
                        type: "pie",
                        label: {
                            normal: {
                                position: 'outseide', // 在内部显示，outseide 是在外部显示
                                show: true,
                                formatter: '{c}',
                            }
                        },
                        top:50,
                        data:listItem,
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: "rgba(0, 0, 0, 0.5)",
                            },
                        },
                    },
                ],
            })
        },


  },
};
</script>
<style scoped lang="scss">

//   .comp:nth-child(2)>.panelBox:nth-child(1)>.panel{
//       border: 1px solid #a7a8aa;
//       border-top: none;
//   }


.comp {
  width: 100%;
  // background-color: #fff;
  // display: flex;
  // flex-wrap: wrap;
  height: 100vh;

  .nucleustit {
    display: flex;
    justify-content: space-between;
    height: 50px;
    box-sizing: border-box;
    padding: 16px 16px 10px 16px;
    background-color: #fff;
    margin: 0 20px 20px 0;

    .tabList {
      display: flex;
    }

    .tabI {
      width: 60px;
      height: 30px;
      font-size: 14px;
      color: #fdfdfd;
      border-radius: 2px;
      margin-left: 20px;
      line-height: 30px;
      padding: 0 7px;
      text-align: center;
      background-color: #F5882A;
      border-color: #F5882A;
      cursor: pointer;

    }

    .tit {
      color: $fontColor;
      font-size: 18px;
      font-weight: bold;
      margin: 4px 0;
      padding: 0 6px;
      box-sizing: border-box;
      height: 20px;
      line-height: 20px;
    }
  }

  .cell {
    display: flex;
    border-radius: 10px;

    div {
      color: #8d8a8a;
      padding: 10px 10px;

    }

    .active {
      // background-color: $mainColor;
      color: #9d9b9b;
      border: 1px solid #a7a8aa;
      font-size: 14px;
      border-radius: 8px;
      cursor: pointer;
    }

    .active1 {
      // background-color: $mainColor;
      color: #9d9b9b;
      border: 1px solid #a7a8aa;
      font-size: 14px;
      border-radius: 8px;
      cursor: pointer;
    }

    .active2 {
      // background-color: $mainColor;
      color: #9d9b9b;
      border: 1px solid #a7a8aa;
      font-size: 14px;
      border-radius: 8px;
      cursor: pointer;
    }
  }

  .panelBox {
    display: flex;
    justify-content: space-around;
    width: 100%;
    .panel2 {
        padding: 22px 20px;
        box-sizing: border-box;
        width: 600px;
        background-color: #fff;

        .tit {
            font-size: 18px;
            color: $fontColor;
            font-weight: bold;
            padding-bottom: 14px;
        }
    }
    .R {
      margin: 0 20px 20px 0;
      width: 100%;

      .rulesLine {
        display: flex;
        justify-content: space-between;
        height: 52px;
        padding: 10px;
        background-color: #fff;
        box-sizing: border-box;
        border-radius: 4px;
        margin: 10px 0;

        .money {
          color: #666666;
          font-size: 14px;
          line-height: 32px;
        }

        .rules {
          color: $mainColor;
          font-size: 12px;
          line-height: 32px;
          cursor: pointer;
        }
      }

      .scoll {
        height: calc(100% - 62px);
        overflow: auto;

        .tabBox {
          padding-bottom: 10px;
          background-color: #fff;

          .tabTit {
            background-color: $tableTitBg;
            display: flex;
            justify-content: space-between;
            height: 44px;
            color: #333333;
            position: relative;

            .colTit {
              width: 20%;
              line-height: 44px;
              padding: 0 20px;
              width: 100%;
              font-size: 14px;

            }

            .see {
              position: absolute;
              right: 38px;
              padding-right: 10px;
              color: #333333;
              flex-grow: 0;
              cursor: pointer;
              width: 28px;
              padding: 0 8px;
            }

            .rule {
              position: absolute;
              right: 0px;
              padding-right: 10px;
              color: $mainColor;
              flex-grow: 0;
              cursor: pointer;
              width: 28px;
              padding: 0 8px;
            }
          }
          .tabItem:nth-child(odd){
            background-color: #f7eded;
          }
          .tabItem {
            background-color: #fff;
            display: flex;
            justify-content: space-between;
            height: 54px;
            color: #333333;
            position: relative;

            .colTit {
              width: 20%;
              line-height: 44px;
              padding: 0 20px;
              width: 100%;
              font-size: 14px;
              // border-bottom: 1px solid #d3d1d1;
            }

            .see {
              position: absolute;
              right: 38px;
              padding-right: 10px;
              color: $mainColor;
              flex-grow: 0;
              cursor: pointer;
              width: 28px;
              padding: 0 8px;
            }

            .rule {
              position: absolute;
              right: 0px;
              padding-right: 10px;
              color: $mainColor;
              flex-grow: 0;
              cursor: pointer;
              width: 28px;
              padding: 0 8px;
            }
          }

          // 补助
          .el-collapse{
            width: 100%;
          }
          .tabItem1 {
            background-color: #fff;
            display: flex;
            justify-content: space-between;
            height: 44px;
            color: #333333;
            position: relative;
            width: 100%;
            .colTit {
              width: 20%;
              line-height: 44px;
              padding: 0 20px;
              width: 100%;
              font-size: 14px;
              // border-bottom: 1px solid #d3d1d1;
            }

            .see {
              position: absolute;
              right: 38px;
              padding-right: 10px;
              color: $mainColor;
              flex-grow: 0;
              cursor: pointer;
              width: 28px;
              padding: 0 8px;
            }

            .rule {
              position: absolute;
              right: 0px;
              padding-right: 10px;
              color: $mainColor;
              flex-grow: 0;
              cursor: pointer;
              width: 28px;
              padding: 0 8px;
            }
          }

          .tabItem2 {
            background-color: #ffffff;
            display: flex;
            justify-content: space-between;
            height: 44px;
            color: #333333;
            position: relative;

            .colTit {
              width: 20%;
              line-height: 44px;
              padding: 0 30px;
              width: 100%;
              font-size: 14px;
              border-bottom: 1px solid #f2f2f2;
            }

            .see {
              position: absolute;
              right: 38px;
              padding-right: 10px;
              color: $mainColor;
              flex-grow: 0;
              cursor: pointer;
              width: 28px;
              padding: 0 8px;
            }

            .rule {
              position: absolute;
              right: 0px;
              padding-right: 10px;
              color: $mainColor;
              flex-grow: 0;
              cursor: pointer;
              width: 28px;
              padding: 0 8px;
            }
          }
        }
      }
    }

    .panel {
      padding: 22px 20px;
      box-sizing: border-box;

      width: calc(100% - 600px);
      background-color: #fff;
      border: 1px solid rgb(211, 209, 209);
      margin-right: 20px;
      text-align: center;
      // line-height: 80px;
    
    }

    .panelitem {
      padding: 22px 20px;
      width: 580px;
      // border: 1px solid rgb(211, 209, 209);
    }


    .nucleuscon {
      margin-top: 10px;
      display: flex;

      .nucleusitem {
        border-right: 1px solid #ddd;
        width: 20%;
        display: flex;
        justify-content: center;
        // display: inline-block;
        box-sizing: border-box;
        margin: auto;
        align-items: center;
        margin-top: 20px;
        line-height: 40px;

        &:last-child {
          border: none;
        }

        .content {
          max-width: 180px;
          margin: auto;
          
        }

        .currentit {
          color: #666666;
          font-size: 14px;
        }

        .data {
          margin: 10px 0;
          font-size: 20px;
          font-weight: bold;
          color: #333333;
        }

        .compare {
          color: #666666;
          font-size: 12px;
        }
      }
    }

  }

 

}

.row:nth-child(odd) {
  background: rgb(223, 218, 218);
}</style>
